class BundleAndSave extends HTMLElement {
  constructor() {
    super();

    //console.log("running");
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);


      


      var this2 = this;

      function setData() {
        var datacolor = $(this2)
          .find(".variant-swatch-active")
          .attr("data-colname");
$('.variant-quick-main-product-value').html($(this2)
          .find(".variant-swatch-active")
          .attr("data-bundle-color"))
        $(
          '.text-with-icon-bundle[data-colname="' + datacolor + '"]'
        ).removeAttr("hidden");
        $('.text-with-icon-bundle[data-colname="' + datacolor + '"]').addClass(
          "active"
        );
        $(
          '.text-with-icon-bundle:not([data-colname="' + datacolor + '"])'
        ).attr("hidden", true);
        $(
          '.text-with-icon-bundle:not([data-colname="' + datacolor + '"])'
        ).removeClass("active");

        var available = true;
        var arcolor = datacolor.split("/");
        $(".main-product-gallery-container").hide();
        $(".main-product-gallery-container").removeClass(
          "active-media-gallery"
        );
        $(
          '.main-product-gallery-container[data-galleryid="' + datacolor + '"]'
        ).show();
        $(
          '.main-product-gallery-container[data-galleryid="' + datacolor + '"]'
        ).addClass("active-media-gallery");
        var totalprice = 0;
        var totalcompprice = 0;
        let longestDeliveryTime = "";
        let longestDurationDays = 0;
        let unavailableOption2 = [];
        let variantRequirements = {};
        $(this2)
          .find(".swatching-product-info")
          .each(function () {
            var curindex = Number($(this).attr("data-index"));
            var datasize = $(this)
              .find(".size-subdued-main-wrapper")
              .find("input:checked")
              .val();

            var matchingOption = $(this)
              .find(".swatch-product-variant-id option")
              .filter(function () {
                return (
                  $(this).attr("data-option1") === arcolor[curindex] &&
                  $(this).attr("data-option2") === datasize
                );
              });

            var variantId = matchingOption.attr("value");
            if (!variantId) return;

            if (!variantRequirements[variantId])
              variantRequirements[variantId] = 0;
            variantRequirements[variantId]++;
          });
        console.log(variantRequirements);
        $(this2)
          .find(".swatching-product-info")
          .each(function () {
            var curindex = Number($(this).attr("data-index"));
            var thissw = this;
            var datasize = $(this)
              .find(".size-subdued-main-wrapper")
              .find("input:checked")
              .val();
            $(this)
              .find(".swatch-product-variant-id")
              .find("option")
              .each(function () {
                const optionColor = $(this).attr("data-option1");
                const optionSize = $(this).attr("data-option2");
                const isAvailable = $(this).attr("data-available");

                // console.log(arcolor[curindex] + " ddd " + datasize);

                if (
                  optionColor === arcolor[curindex] &&
                  isAvailable === "false"
                ) {
                  unavailableOption2.push(optionSize);
                }

                if (
                  arcolor[curindex] == $(this).attr("data-option1") &&
                  datasize == $(this).attr("data-option2")
                ) {
                  //console.log($(this).attr("data-varianttitle") + " sssss");
                  $(thissw).find("img").attr("src", $(this).attr("data-image"));
                  $(thissw)
                    .find(".swatching-product-info-color")
                    .html(arcolor[curindex]);
                  $(thissw)
                    .find(".swatch-product-variant-id")
                    .val($(this).attr("value"));
                  totalprice = totalprice + Number($(this).attr("data-price"));
                  totalcompprice =
                    totalcompprice + Number($(this).attr("data-compprice"));

                  $(".product-info__inventory")
                    .find(".text-with-icon")
                    .attr("hidden", true);
                  $(".product-info__inventory")
                    .find(
                      '.text-with-icon[data-variant-id="' + $(this).val() + '"]'
                    )
                    .removeAttr("hidden");

                  // START delivery time logic
                  var deliverytime = $(this).data("deliverytime");
                  if (deliverytime) {
                    //  console.log("deliverytime=" + deliverytime);

                    let durationMatch = deliverytime.match(
                      /(\d+)(?:[-–](\d+))?\s*(Wochen|Werktagen)/i
                    );

                    if (deliverytime == "Bald wieder für dich verfügbar") {
                      longestDeliveryTime = deliverytime;
                    } else if(deliverytime == "Auf Lager! In 1-3 Werktagen bei dir"){
                      longestDeliveryTime = deliverytime;
                    } else if (durationMatch) {
                      let from = parseInt(durationMatch[1]);
                      let to = durationMatch[2]
                        ? parseInt(durationMatch[2])
                        : from;
                      let unit = durationMatch[3].toLowerCase();
                      let maxDuration = to;

                      // Convert weeks to days
                      if (unit.includes("woche")) {
                        maxDuration *= 7;
                      }

                      if (maxDuration > longestDurationDays) {
                        longestDurationDays = maxDuration;
                        longestDeliveryTime = deliverytime;
                      }
                    } else if (longestDurationDays === 0) {
                      // No time extracted, keep earliest/default
                      longestDeliveryTime = deliverytime;
                    }
                  }
                  // const variantId = $(this).attr("value");
                  // const inventoryQty = parseInt($(this).attr("data-inventory"));
                  // if (typeof inventoryQty === 'number' && !isNaN(inventoryQty)) {
                  //   console.log(variantId + ' ddd ' + inventoryQty)
                  //   console.log(variantCount[variantId] + ' ddd ' + inventoryQty)
                  //   if (variantCount[variantId] > inventoryQty) {
                  //     available = false;
                  //   }
                  // } else {
                  //   if ($(this).attr("data-available") == "false") {
                  //     available = false;
                  //   }
                  // }
                }
              });
          });

        // $(".size-subdued-main-wrapper label").removeClass("is-disabled");
        // unavailableOption2.forEach(function (unavailSize) {
        //   $(".size-subdued-main-wrapper input").each(function () {
        //     if ($(this).val() === unavailSize) {
        //       const inputId = $(this).attr("id");
        //       $('label[for="' + inputId + '"]').addClass("is-disabled");
        //     }
        //   });
        // });
        let allAvailable = true;
        Object.keys(variantRequirements).forEach(function (variantId) {
          var optionEl = $(`option[value="${variantId}"]`);
          var inventoryQty = parseInt(optionEl.attr("data-inventory"));
          console.log(variantRequirements[variantId] + "  dd  " + inventoryQty);
          if (variantRequirements[variantId] > inventoryQty) {
            allAvailable = false;
          }
        });

        $(".size-subdued-main-wrapper label").removeClass("is-disabled");
        $(".size-subdued-main-wrapper input").each(function () {
          const inputId = $(this).attr("id");
          const sizeVal = $(this).val();
          let availableInAnyColor = false;

          let variantCountMap = {};
          $(this2)
            .find(".swatching-product-info")
            .each(function () {
              var currentIdx = Number($(this).attr("data-index"));

              var foundOption = $(this)
                .find(".swatch-product-variant-id option")
                .filter(function () {
                  return (
                    $(this).attr("data-option1") === arcolor[currentIdx] &&
                    $(this).attr("data-option2") === sizeVal
                  );
                });

              var foundVariantId = foundOption.attr("value");
              if (!foundVariantId) return;

              if (!variantCountMap[foundVariantId])
                variantCountMap[foundVariantId] = 0;
              variantCountMap[foundVariantId]++;
            });

          console.log("variantCountMap = " + variantCountMap);

          let allItemsAvailable = true;
          Object.keys(variantCountMap).forEach(function (variantKey) {
            var variantOptionElem = $(`option[value="${variantKey}"]`);
            var availableQty = parseInt(
              variantOptionElem.attr("data-inventory")
            );
            if (variantCountMap[variantKey] > availableQty) {
              allItemsAvailable = false;
            }
          });

          if (!allItemsAvailable) {
            $('label[for="' + inputId + '"]').addClass("is-disabled");
            // $(this).prop("disabled", true);
          } else {
            //$(this).prop("disabled", false);
          }
        });

        if (allAvailable == false) {
          $(".bundle-icon-success").hide();
          $(".bundle-icon-warning").hide();
          $(".bundle-icon-outofstock").show();
          $(".fd_cd_info_text").html('Bald wieder für dich verfügbar');
        } else {
          if (
            longestDeliveryTime.includes("Auf Lager") ||
            longestDurationDays <= 3
          ) {
            $(".text-with-icon-bundle")
              .removeClass("text-warning")
              .addClass("text-success");
            $(".bundle-icon-success").show();
            $(".bundle-icon-warning").hide();
            $(".bundle-icon-outofstock").hide();
          } else {
            $(".text-with-icon-bundle")
              .removeClass("text-success")
              .addClass("text-warning");
            $(".bundle-icon-success").hide();
            $(".bundle-icon-warning").show();
            $(".bundle-icon-outofstock").hide();
          }
          $(".fd_cd_info_text").html(longestDeliveryTime);
        }

        if ($(".package-container").length > 0) {
          // console.log(totalprice);
          $(".package-container")
            .find(".quantity-selectors__input")
            .attr("data-price", totalprice);
          $(".package-container")
            .find(".quantity-selectors__input")
            .attr("data-comprice", totalcompprice);
          $(".quantity-selectors__input").trigger("change");
        }

        // console.log("available " + available);

        console.log(allAvailable);
        if (allAvailable == false) {
          $(this2)
            .parents(".product-info")
            .find(".custom-product-atc-button")
            .find("button")
            .attr("disabled", true);
          $(this2)
            .parents(".product-info")
            .find(".custom-product-atc-button")
            .find("button")
            .find("div")
            .html("Ausverkauft");
          $(".text-with-icon-bundle").removeClass("text-success");
          $(".bundle-icon-success").hide();
          $(".bundle-icon-warning").hide();
          $(".bundle-icon-outofstock").show();
        } else {
          $(".text-with-icon-bundle").addClass("text-success");
          $(this2)
            .parents(".product-info")
            .find(".custom-product-atc-button")
            .find("button")
            .removeAttr("disabled");
          $(this2)
            .parents(".product-info")
            .find(".custom-product-atc-button")
            .find("button")
            .find("div")
            .html("In den Warenkorb");
        }
      }

      $(this)
        .find(".container-swatch-inner")
        .click(function () {
          $(this2).find(".variant-swatch").removeClass("variant-swatch-active");
          $(this).addClass("variant-swatch-active");
          setData();
        });
      $(this)
        .find(".size-subdued-main-wrapper")
        .find("input")
        .change(function () {
          var pid = $(this).parents(".swatching-product-info").attr("data-pid");
          var csize = $(this).attr("value");
          // console.log("csize==" + csize);
          if ($(".product-variant-content").length > 0) {
            $(".product-variant-content").find(".productvarsize").text(csize);
          }

          $('.swatching-product-info[data-pid="' + pid + '"]').each(
            function () {
              $(this)
                .find('input[value="' + csize + '"]')
                .click();
            }
          );
          setData();
        });
      setData();

      $(".product-info__price").show();

      $(this2)
        .parents(".product-info")
        .find(".custom-product-atc-button")
        .find("button")
        .click(async function (e) {
          e.preventDefault();
          e.stopPropagation();

          const $button = $(this).attr("aria-busy", true);
          $(".erromsg").remove();
          const thisButton = this;
          const $visibleInfo = $(".product-swatching-product-info:visible");
          const pid = $visibleInfo.attr("data-pid");
          const csize = $visibleInfo
            .find(".size-subdued-main-wrapper input:checked")
            .val();

          // Trigger click on all inputs with the same selected size
          $(`.swatching-product-info[data-pid="${pid}"]`).each(function () {
            const $sizeInput = $(this).find(`input[value="${csize}"]`);
            //console.log($sizeInput.val());
            $sizeInput.click();
          });

          // Update displayed variant size if applicable
          if ($(".product-variant-content").length > 0) {
            $(".product-variant-content .productvarsize").text(csize);
          }

          // Product title
          const title = $(this2)
            .parents(".product-info")
            .find(".product-info__title")
            .html()
            .trim();
          let qty = 1;

          // Quantity logic for package-progress
          if ($(".package-progress-container").length > 0) {
            const productscount = $(".package-container").data("productscount");
            const packqty = parseInt(
              $(".package-progress-container").attr("data-currentindex"),
              10
            );

            if (productscount === 2) {
              if (packqty === 4) qty = 2;
              else if (packqty === 6) qty = 3;
            } else {
              if (packqty === 6) qty = 2;
              else if (packqty === 9) qty = 3;
            }
          }

          // Build item data

          const item = {
            id: $(
              ".main-product-bundle-save-parent .container-swatch-inner.variant-swatch-active"
            ).attr("data-varid"),
            quantity: qty,
            properties: {},
          };

          const $firstSwatch = $(this2).find(".swatching-product-info").eq(0);
          const selectedVariant = $firstSwatch
            .find(".swatch-product-variant-id option:selected")
            .val();

          // Deduplicate variant IDs and count quantities
          const bitemMap = {};

          $(this2)
            .find(".swatching-product-info")
            .each(function () {
              const $option = $(this).find(
                ".swatch-product-variant-id option:selected"
              );
              const variantId = $option.val();
              const baseTitle = $option.attr("data-varianttitle");
              // console.log("baseTitle==" + baseTitle);
              if (bitemMap[variantId]) {
                bitemMap[variantId].qty += 1;
              } else {
                bitemMap[variantId] = {
                  qty: 1,
                  baseTitle: baseTitle,
                };
              }
            });

          // Build comma-separated values
          let bitemIds = "";
          let bitemQtys = "";
          let bitemIncluded = "";

          Object.entries(bitemMap).forEach(([id, data]) => {
            bitemIds += "," + id;
            bitemQtys += "," + data.qty;

            const qtySuffix = data.qty > 1 ? ` (x${data.qty})` : "";
            bitemIncluded += "\r\n, " + data.baseTitle + qtySuffix;
          });

          // Assign properties
          item.properties["_bitemIds"] = bitemIds.substring(1);
          item.properties["_bitemQtys"] = bitemQtys.substring(1);
          item.properties["Enthält"] = bitemIncluded.substring(4);
          const deliveryTime = $(`.text-with-icon-bundle.active`).text().trim();
          //console.log("deliveryTime==" + deliveryTime);
          item.properties["_deliverytime"] = deliveryTime;

          const items = [];
          items.push(item);
          const sectionsToBundle = ["variant-added"];

          document.dispatchEvent(new CustomEvent("triggeroptionchange"));
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:prepare-bundled-sections", {
              bubbles: true,
              detail: { sections: sectionsToBundle },
            })
          );

          try {
            const response = await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
              body: JSON.stringify({
                items: items,
                sections: sectionsToBundle.join(","),
                sections_url: `${Shopify.routes.root}`,
              }),
            });

            const responseJson = await response.json();

            thisButton.removeAttribute("aria-busy");

            if (response.ok) {
              const cartContent = await (
                await fetch(`${Shopify.routes.root}cart.js`)
              ).json();
              cartContent["sections"] = responseJson["sections"];

              document.dispatchEvent(
                new CustomEvent("variant:add", {
                  bubbles: true,
                  detail: {
                    items: responseJson.items || [responseJson],
                    cart: cartContent,
                  },
                })
              );

              document.documentElement.dispatchEvent(
                new CustomEvent("cart:change", {
                  bubbles: true,
                  detail: {
                    baseEvent: "variant:add",
                    cart: cartContent,
                  },
                })
              );
            } else {
              throw new Error(
                responseJson.description || "Failed to add to cart"
              );
            }
          } catch (err) {
            $(thisButton).after(
              `<div style="color:red;margin-top:5px;font-size:14px;" class="erromsg">${err.message}</div>`
            );
            thisButton.removeAttribute("aria-busy");
          }
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("bundle-and-save", BundleAndSave);
